import { Action, createBrowserHistory, History, Location } from 'history';
import queryString from 'query-string';
import { useEffect, useMemo, useState } from 'react';

export default function useHistory<HistoryState = any>(): {
  location: Location;
  action?: Action;
  push: History['push'];
} {
  const history: History<HistoryState> = useMemo(createBrowserHistory, []);

  const [{ action, location }, setLocation] = useState<{
    action?: Action;
    location: Location<HistoryState>;
  }>({ location: history.location });

  useEffect(() => {
    const unlisten = history.listen((newLocation, newAction) => {
      setLocation({ location: newLocation, action: newAction });
    });
    return unlisten;
  }, [history]);

  return { location, action, push: history.push.bind(history) };
}

export function mergeQueryParams<S>(
  location: Location<S>,
  newParams: object
): Location<S> {
  return {
    ...location,
    search: `?${queryString.stringify({
      ...queryString.parse(location.search),
      ...newParams,
    })}`,
  };
}
